import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import Editor from 'components/editor'
import { useAppServices } from 'hook/services'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

const CreateModal = ({ handleRefresh, categories, apps }) => {
  const AppService = useAppServices()
  const [open, setOpen] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [answer, setAnswer] = useState('')

  const [formValues, setFormValues] = useState({
    question: '',
    category_id: '',
    app_name: apps.name, // Pre-populate with app name
  })

  const [filteredCategories, setFilteredCategories] = useState([])

  useEffect(() => {
    // Filter categories based on app_id
    const filtered = categories.filter(category => category.app_id === apps.app_id)
    setFilteredCategories(filtered)
  }, [categories, apps])

  const handleModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      ...formValues,
      answer,
    }

    const { response } = await AppService.AppsFaq.create_onboard({ payload })

    if (response) {
      setProcessing(false)
      closeModal()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create FAQ
      </MDButton>

      <MDModal open={open} onClose={closeModal}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Create FAQ
          </MDTypography>

          {/* App Name (hidden but included in form data) */}
          <input type="hidden" name="app_name" value={formValues.app_name} />

          {/* App Name Display (Read-only) */}
          <MDBox mb={2}>
            <MDTypography variant="button">App</MDTypography>
            <MDInput value={apps.name} fullWidth disabled />
          </MDBox>

          {/* Category Dropdown */}
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel id="category-label">Category</InputLabel>
              <Select
                labelId="category-label"
                name="category_id"
                value={formValues.category_id}
                label="Category"
                onChange={handleChange}
                required
              >
                {filteredCategories.map((category) => (
                  <MenuItem key={category._id} value={category._id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>

          {/* Question */}
          <MDBox mb={2}>
            <MDTypography variant="button">Question</MDTypography>
            <MDInput
              name="question"
              fullWidth
              required
              onChange={handleChange}
              placeholder="Enter the question"
            />
          </MDBox>

          {/* Answer */}
          <MDBox mb={2}>
            <MDTypography variant="button">Answer</MDTypography>
            <Editor handleChange={setAnswer} />
          </MDBox>

          {/* Actions */}
          <MDBox display="flex" justifyContent="flex-end">
            <MDButton variant="gradient" color="secondary" onClick={closeModal} sx={{ mt: 2, mb: 1 }}>
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ mt: 2, mb: 1, ml: 1 }}
              loading={processing}
              disabled={processing}
            >
              Submit
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal